import { Time } from '@internationalized/date'
import { TimeValue } from '@react-aria/datepicker'
import { CustomTime } from './types'

export const customTimeToTimeValue = (customTime: CustomTime): Time => {
  let hour24 = customTime.hour
  if (customTime.amOrPm === 'pm' && customTime.hour !== 12) {
    hour24 = customTime.hour + 12
  } else if (customTime.amOrPm === 'am' && customTime.hour === 12) {
    hour24 = 0
  }
  return new Time(hour24, customTime.minute)
}

export const timeValueToCustomTime = (timeValue: TimeValue): CustomTime => {
  const hour12 = timeValue.hour % 12 || 12
  const amOrPm = timeValue.hour < 12 ? 'am' : 'pm'
  return {
    hour: hour12,
    minute: timeValue.minute,
    amOrPm,
  }
}

export const formatCustomTime = (customTime: CustomTime): string => {
  const formattedMinute = customTime.minute.toString().padStart(2, '0')
  return `${customTime.hour}:${formattedMinute}${customTime.amOrPm}`
}
